var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowing)?_c('div',{ref:"interactElement",staticClass:"card",class:{
    isAnimating: _vm.isInteractAnimating,
    isCurrent: _vm.isCurrent
  },style:({ transform: _vm.transformString })},[_c('AdCard',{attrs:{"ad":_vm.card,"likeorpass":_vm.likeorpass},on:{"update:likeorpass":function($event){_vm.likeorpass=$event},"imageFailed":_vm.imageFailed}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }